import { InputGroup, InputRightElement, NumberInput, NumberInputField } from '@chakra-ui/react';
import { getCurrencyChar } from '@jurnee/common/src/utils/prices';
import { FormControl } from './primitives/FormControl';

export interface Props {
  label?: string;
  defaultValue?: number;
  placeholder?: string;
  isInvalid?: boolean;
  isRequired?: boolean;
  currency: string;
  onChange(value: number): void;
}

export function PriceInput({ label, currency, defaultValue, placeholder, isInvalid, isRequired, ...props }: Props) {
  function onChange(value: string) {
    const amount = parseFloat(value);

    props.onChange(isNaN(amount) ? 0 : amount);
  }

  return (
    <FormControl label={label} isInvalid={isInvalid} isRequired={isRequired}>
      <InputGroup size="sm">
        <NumberInput
          w="100%"
          min={0}
          defaultValue={defaultValue}
          onChange={onChange}
        >
          <NumberInputField bg="white" pl={3} pr="48px" placeholder={placeholder} />
        </NumberInput>

        <InputRightElement width="48px" pointerEvents="none" color="gray.400" display="flex" justifyContent="flex-end" pr={3}>
          { getCurrencyChar(currency) }
        </InputRightElement>
      </InputGroup>
    </FormControl>
  );
}